import { render, staticRenderFns } from "./TicimaxIcon.vue?vue&type=template&id=f9b3e800&scoped=true"
import script from "./TicimaxIcon.vue?vue&type=script&lang=js"
export * from "./TicimaxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b3e800",
  null
  
)

export default component.exports